import axios from "axios";

export const userService = {
  login,
  logout,
  forgotPassword,
  getCurrentUser,
  changePassword,
  getStaffDepartmentsMembersCateogries,
  loginKeyCloak,
};

function login(params) {
  return axios.post("/v1/signin", params);
}

function loginKeyCloak(code) {
  return axios.post("/v1/signin_with_keycloak_code", { code: code });
}

function logout() {
  return axios.delete("/v1/signout");
}

function getCurrentUser() {
  return axios.get("/v1/current_user");
}

function getStaffDepartmentsMembersCateogries() {
  return axios.get("/v1/departments_members_categories");
}

function forgotPassword(params) {
  return axios.post("/v1/forgot_password", params);
}

function changePassword(params) {
  return axios.post("/v1/reset_pasword", params);
}
